export const initialAbility = [
  {
    action: 'read',
    subject: 'No-Auth',
  },
]

export const _ = undefined
